import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "col-12 border-top pt-4" };
const _hoisted_2 = { class: "font6-responsive strong mb-3 d-inline-block" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("img", {
    src: "/images/icons/clear.svg",
    alt: "x",
    class: "mr-1"
}, null, -1);
const _hoisted_4 = {
    key: 0,
    class: "col-12 pt-3 readMoreLinkWrapper"
};
const _hoisted_5 = {
    class: "font7-responsive link-gray strong",
    title: "mehr anzeigen"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_checkbox_input = _resolveComponent("checkbox-input");
    return (_ctx.filterContent.length > 1)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([_ctx.filterHeadline, "filterBoxUniversal row pb-4"])
        }, [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.filterHeadline) + ":", 1),
                _createElementVNode("div", {
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.resetFilters && _ctx.resetFilters(...args))),
                    title: "löschen",
                    class: "link-gray strong font7-responsive float-right pointer-event"
                }, [
                    _hoisted_3,
                    _createTextVNode(" löschen ")
                ]),
                _renderSlot(_ctx.$slots, "extraFilterContent")
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentFilterItems, (filter, index) => {
                return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "col-12"
                }, [
                    _createVNode(_component_checkbox_input, {
                        id: filter.displayValue,
                        name: filter.displayValue,
                        text: filter.displayValue,
                        value: filter.numericValue,
                        modelValue: filter.checked,
                        "onUpdate:modelValue": [($event) => ((filter.checked) = $event), _ctx.applyCheckbox]
                    }, null, 8, ["id", "name", "text", "value", "modelValue", "onUpdate:modelValue"])
                ]));
            }), 128)),
            (_ctx.filterContent.length > 5)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        (!_ctx.showAll)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.showAll = true)),
                                class: "d-block"
                            }, _toDisplayString(_ctx.filterContent.length - 5) + " weitere.. ", 1))
                            : _createCommentVNode("", true),
                        (_ctx.showAll)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.showAll = false)),
                                class: "d-block"
                            }, "weniger anzeigen"))
                            : _createCommentVNode("", true)
                    ])
                ]))
                : _createCommentVNode("", true)
        ], 2))
        : _createCommentVNode("", true);
}
